<header class="topbar">

  <!-- Mobile: Logo -->
  <!-- <img src="assets/images/Yaldi Logo Main-01.svg" alt="Logo" class="topbar-logo-mobile md:hidden" /> -->
  <!-- Mobile hamburger -->
  <button class="icon-btn-menu md:hidden" (click)="toggleSideNav()" title="Menu">
    <i class="fa-solid fa-bars"></i>
  </button>
  <!-- Desktop: Breadcrumbs -->
  <nav class="crumbs flex">
    @for (crumb of breadcrumbs(); track crumb.label; let i = $index, last = $last) {
    @if (i > 0) {
    <img src="assets/icons/back-slash.svg" alt="back-slash"> }
    <span [class.here]="last">{{ crumb.label.charAt(0).toUpperCase() + crumb.label.slice(1).toLowerCase() }}</span>
    }
  </nav>

  <div class="topbar-spacer"></div>

  <!-- Actions -->
  <div class="topbar-actions">
    <button class="icon-btn" title="Notifications" disabled>
      <img src="assets/icons/bell.svg" alt="bell">
    </button>
    <button class="icon-btn" (click)="toggleMode()" [title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'">
      <img [class]="isDark()?'' :''" src="assets/icons/theme.svg" alt="theme">
    </button>
  </div>
</header>